import Vue from 'vue';
import VueI18n from 'vue-i18n';
import esMX from './lang/es-MX';
import deDE from './lang/de-DE';
import itIT from './lang/it-IT';
import enUS from './lang/en-US';
import ptBR from './lang/pt-BR';

const locale = document.body.querySelector('input[name="_locale"]').value;

Vue.use(VueI18n);

const messages = {
  'es-MX': esMX,
  'de-DE': deDE,
  'it-IT': itIT,
  'en-US': enUS,
  'pt-BR': ptBR
};

export default new VueI18n({
  locale: locale,
  messages
});
